module.exports = __webpack_public_path__ + "static/media/orangeTheme-boy.7aaf3ccd.svg";